import React, { useContext } from "react"
import { Div, Text, Image } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faShieldHalved,
	faBug,
	faCodeBranch,
	faShareNodes,
	faFileLines,
} from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import Card from "../Card"
import Divider from "../atoms/Divider"
import { theme } from "../settings/config"
import { APP_VERSION, BUILD_COMMIT } from "../settings/version"
import { modalContext } from "../providers/modal.provider"

const AboutCard = () => {
	const Modal = useContext(modalContext)

	const Row = ({ icon, text, href, onClick }) => (
		<Div
			tag={href ? "a" : "div"}
			href={href}
			target={href ? "_blank" : undefined}
			rel={href ? "noopener noreferrer" : undefined}
			onClick={onClick}
			d="flex"
			align="center"
			p={{ y: "0.6rem" }}
			cursor="pointer"
			style={{ gap: "0.6rem", textDecoration: "none" }}>
			<FontAwesomeIcon icon={icon} color={theme.colors.text_light} size="sm" />
			<Text textSize="subheader" textColor={theme.colors.gunmetal}>
				{text}
			</Text>
		</Div>
	)

	// Sul telefono apre il pannello di condivisione del sistema; altrove —
	// e ovunque manchi l'API — ripiega sulla copia del link.
	const handleShare = async () => {
		const url = window.location.origin
		try {
			if (navigator.share) {
				await navigator.share({
					title: "inCampo",
					text: "Il gestionale per i maestri di tennis e padel",
					url,
				})
				return
			}
			await navigator.clipboard.writeText(url)
			toast.success("Link copiato! 🔗", { position: "top-center" })
		} catch (err) {
			// l'utente ha chiuso il pannello di condivisione: non è un errore
			if (err?.name === "AbortError") return
			toast.error("Non è stato possibile condividere il link", { position: "top-center" })
		}
	}

	return (
		<Card bg={theme.colors.surface}>
			<Div d="flex" align="center" justify="space-between">
				<Image src={require("../images/incampo_logo.png")} w="6rem" />
				<Div d="flex" align="center" style={{ gap: "0.4rem" }}>
					<FontAwesomeIcon
						icon={faCodeBranch}
						color={theme.colors.text_light}
						size="xs"
					/>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						{APP_VERSION}
						{BUILD_COMMIT && ` · ${BUILD_COMMIT}`}
					</Text>
				</Div>
			</Div>

			<Divider w="2px solid" borderColor={theme.colors.background} m={{ y: "0.75rem" }} />

			<Row icon={faShareNodes} text="Condividi inCampo" onClick={handleShare} />
			<Row icon={faShieldHalved} text="Informativa sulla privacy" href="/privacy.html" />
			<Row icon={faFileLines} text="Termini di servizio" href="/termini.html" />
			<Row
				icon={faFileLines}
				text="Accordo sul trattamento dei dati"
				href="/trattamento-dati.html"
			/>
			{/* Un modulo dentro l'app, non una mail: dal telefono la mail non
			    sempre parte, e chi scrive dovrebbe spiegare dove si trovava.
			    Versione, pagina e circolo li allega il modulo da solo. */}
			<Row
				icon={faBug}
				text="Segnala un problema"
				onClick={() => Modal.open("feedback")}
			/>

			<Divider w="2px solid" borderColor={theme.colors.background} m={{ y: "0.75rem" }} />

			<Text textSize="caption" textColor={theme.colors.text_light} textAlign="center">
				inCampo — il gestionale per i maestri di tennis e padel
			</Text>
			<Text textSize="caption" textColor={theme.colors.text_light} textAlign="center">
				di Luca Morosini
			</Text>
		</Card>
	)
}

export default AboutCard
